import { Identifier } from 'dashboard/models/identifier';
import { FieldSchema } from 'lib/fields';
import { ApiListRelationship, ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';
import { RelationSchema } from 'lib/relations';
import { Iso8601DateString } from 'lib/types';

export interface TransactionTypeAttributes {
  name: string;
  'environment-id': string;
  status: TransactionTypeStatus;
  'field-schemas': FieldSchema[];
  'relation-schemas': RelationSchema[];
  // TODO: Remove the `?` after the initial deploy ensures the backend always returns `identifiers`
  identifiers?: Identifier[];
  'created-at'?: Iso8601DateString;
  'updated-at'?: Iso8601DateString;
  'deactivated-at'?: Iso8601DateString;
  'default-status-id'?: string;
}

export interface TransactionTypeFilterOption {
  id: string;
  name: string;
  status: TransactionTypeStatus;
  'deactivated-at'?: Iso8601DateString;
  'updated-at'?: Iso8601DateString;
}

export interface TransactionTypeFiltersMeta {
  filters: TransactionTypeFilterOption[];
}

export enum TransactionTypeStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export interface TransactionTypeRelationships {
  'default-status': ApiRelationship<ApiModel.TransactionStatus>;
  statuses: ApiListRelationship<ApiModel.TransactionStatus>;
}

export type TransactionType = ApiResource<
  TransactionTypeAttributes,
  TransactionTypeRelationships,
  ApiModel.TransactionType
>;

export interface TransactionTypeFiltersResponse {
  meta: TransactionTypeFiltersMeta;
}
